// @flow

import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'react-router-redux'
import { browserHistory } from 'react-router'
import rootReducer from './rootReducer'
import rootSaga from './sagas'
import sentry from './sentry'

export default function configureStore(initialState: Object) {
  const sagaMiddleware = createSagaMiddleware()
  const storeEnhancers = [
    applyMiddleware(
      sentry, // sentry needs to be at first on the list
      routerMiddleware(browserHistory),
      sagaMiddleware
    ),
  ]

  if (window.devToolsExtension) {
    storeEnhancers.push(window.devToolsExtension())
  }

  const store = compose(...storeEnhancers)(createStore)(
    rootReducer,
    initialState
  )
  sagaMiddleware.run(rootSaga)
  return store
}



// WEBPACK FOOTER //
// ./src/configureStore.js